const initialState = [];

const reducer = function retailPriceTypeReducer(state = initialState, action) {
	const newState = [...state];
	switch (action.type) {
		case 'RECEIVE_RETAIL_PRICE_TYPE':
			// if (action.response.result.length === 0) {
			//   return newState;
			// }
			const types = action.response.result;
			return types;
		default:
			return state;
	}
};

export default reducer;
